import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule,  } from "@spartacus/storefront";
import { KbStoreFinderComponent } from "./kb-store-finder.component";
import { FormsModule } from "@angular/forms";
import { StoreFinderHeaderComponent } from "../store-finder-header/store-finder-header.component";
import { RouterModule } from "@angular/router";


@NgModule({
 imports:[
  CommonModule,
  PageLayoutModule,
  OutletModule,
  OutletRefModule,
  RouterModule,
  PageSlotModule,
  I18nModule,
  FormsModule,
  ConfigModule.withConfig({
    cmsComponents: {
        locationFinderFlexComponent: {
        component: StoreFinderHeaderComponent,
      }
    }
  } as CmsConfig)
 ],
 providers:[ 
  ],
 declarations:[KbStoreFinderComponent ,StoreFinderHeaderComponent]
})
export class KbStoreFinderModule {

}
